import { financialFramesActions } from './slice';
import {
  FinancialFrame,
  FinancialFrameUpdate,
  GlobalForecast,
  GlobalForecastAdjustment,
  GlobalForecastSubPortfolio,
} from './stateType';

export const fetchFinancialFrames =
  financialFramesActions.fetchFinancialFrames as () => void;

export const updateFinancialFrame =
  financialFramesActions.updateFinancialFrame as (payload: {
    id: number;
    body: FinancialFrameUpdate;
  }) => void;

export const fetchGlobalForecast =
  financialFramesActions.fetchGlobalForecast as (fiscalYear: string) => void;

export const submitGlobalForecast =
  financialFramesActions.submitGlobalForecast as (
    payload: GlobalForecastAdjustment,
  ) => void;

// actions needed for tests

export const fetchFinancialFramesSuccessAction =
  financialFramesActions.fetchFinancialFramesSuccess as (
    payload: FinancialFrame[],
  ) => void;

export const updateFinancialFrameSuccessAction =
  financialFramesActions.updateFinancialFrameSuccess as (payload: {
    id: number;
    body: FinancialFrameUpdate;
  }) => void;

export const fetchGlobalForecastSuccessAction =
  financialFramesActions.fetchGlobalForecastSuccess as (
    payload: GlobalForecast,
  ) => void;

export const fetchGlobalForecastErrorAction =
  financialFramesActions.fetchGlobalForecastError as (payload: Error) => void;

export const submitGlobalForecastSuccessAction =
  financialFramesActions.submitGlobalForecastSuccess as (
    payload: GlobalForecastSubPortfolio,
  ) => void;

export const submitGlobalForecastErrorAction =
  financialFramesActions.submitGlobalForecastError as (payload: Error) => void;
